import { connect } from 'react-redux';
import Sidebar from './sidebar';
import { getVisibleOrders } from '../../reselect/order.selector';
import { printArticleList, finishRoutePlanning, editRoutePlanning, openRouteDialog, proceedAllVisibleOrders } from '../../reducers/order.reducers';

const mapStateToProps = state => ({
  orders: getVisibleOrders(state),
  selectedMode: state.orders.selectedMode,
  isRoutePlanning: state.orders.routeplanning,
  isEPosPrinterEnabled: state.app.localSettings.useEposPrinter,
  showPrintAllOrders: !!state.app.localSettings.showPrintAllOrders,
  localSettings: state.app.localSettings,
  productionPlaces: state.menu.productionPlaces,
  proceedingOrders: state.orders.proceedingOrders,
});

const mapDispatchToProps = (dispatch) => ({
  printArticleList: (articles) => dispatch(printArticleList(articles)),
  editRoutePlanning: () => dispatch(editRoutePlanning()),
  finishRoutePlanning: () => dispatch(finishRoutePlanning()),
  openRouteDialog: () => dispatch(openRouteDialog()),
  proceedAllVisibleOrders: () => dispatch(proceedAllVisibleOrders()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
